import { request } from "./authApi";

// Public: no token needed, matches the backend's Section A /articles routes.
export function getArticles() {
  return request("/articles");
}

export function getArticle(id) {
  return request(`/articles/${id}`);
}

// Admin only (Section C on the backend) — token must belong to an admin.
// formData must contain "title_fa"/"title_en", "body_fa"/"body_en", and
// may contain repeated "footnotes_fa"/"footnotes_en", an optional
// "image" file, and/or "remove_image" — sent as multipart, not JSON,
// since it may carry a binary upload.
export function createArticle(token, formData) {
  return request("/articles", { method: "POST", body: formData, token });
}

export function updateArticle(token, id, formData) {
  return request(`/articles/${id}`, { method: "PUT", body: formData, token });
}

export function deleteArticle(token, id) {
  return request(`/articles/${id}`, { method: "DELETE", token });
}
